import { useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./Blogs.gql";

export const useHomeBlogsListing = () => {
  const { getBlogsQuery } = DEFAULT_OPERATIONS;
  const { data } = useQuery(getBlogsQuery, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    context: { fetchOptions: { method: "GET" } },
  });

  return {
    BlogsData: data && data.mpBlogPosts && data.mpBlogPosts.items,
  };
};
